import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { useRoutingInfo } from "components/carrot-plans/context/RoutingInfoContext"

const ViewName = Steps.WHAT_KIND_OF_JOURNEY_FINAL_DECISION
export default function WhatKindOfJourneyFinalDecisionStep(): JSX.Element {
  const { routingData } = useRoutingInfo()
  const journeyValue = routingData?.journey

  const { setNextStep } = useStateMachine(ViewName, journeyValue)
  useEffect(() => {
    setNextStep(ViewName, journeyValue)
  })
  return <></>
}
